import request from '@/utils/request'
const api = {
  getVideoInvestList: 'video_invest/getVideoInvestList',
  getMyInvestList: 'video_invest/getMyInvestList',
  snapUp: 'video_invest/snapUp',
  payInvest: 'video_invest/payInvest',
  payAdvIncome: 'video_invest/payAdvIncome'
}
export default {
  getVideoInvestList(parameter) {
    return request({
      url: api.getVideoInvestList,
      method: 'POST',
      data: parameter
    })
  },
  getMyInvestList(parameter) {
    return request({
      url: api.getMyInvestList,
      method: 'POST',
      data: parameter
    })
  },
  payInvest(parameter) {
    return request({
      url: api.payInvest,
      method: 'POST',
      data: parameter
    })
  },
  payAdvIncome(parameter) {
    return request({
      url: api.payAdvIncome,
      method: 'POST',
      data: parameter
    })
  },
  snapUp(parameter) {
    return request({
      url: api.snapUp,
      method: 'POST',
      data: parameter
    })
  }
}
